import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"

export type UserAdministration_RoleType = {
  Code: string
  U_PrtPermissions?: string
  U_RoleDesc?: string
  Grp?: string
  U_Val1?: number
  U_Val2?: number
  U_Text1?: string
  U_Text2?: string
  U_Text3?: string
  U_Json1?: string
}

let columns: { [key in keyof UserAdministration_RoleType]: SYSColumnDef } = {
  Grp: {
    sortable: true,
    filter: { columnFilter: { type: "none" } },
    schema: { isCalculatedColumn: true },
    ui: { visibility: "Table" },
  },

  Code: {
    sortable: true,
    ui: { labelTranslationKey: "SYSUserAdministrationColRole" },
  },
  U_RoleDesc: {
    control: "textarea",
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleDesc",
      expandTableCellOnClick: true,
    },
  },
  U_Json1: {
    control: "textarea",
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleJson1",
      expandTableCellOnClick: true,
    },
  },

  U_Val1: {
    type: "decimal",
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleVal1",
    },
  },
  U_Val2: {
    type: "decimal",
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleVal2",
    },
  },
  U_Text1: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleText1",
      align: "center",
      expandTableCellOnClick: true,
    },
  },
  U_Text2: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleText2",
      align: "center",
      expandTableCellOnClick: true,
    },
  },
  U_Text3: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationColRoleText3",
      align: "center",
      expandTableCellOnClick: true,
    },
  },
}

export let tblUserAdministration_Role: SYSTableDef = {
  id: "SYSUserAdministration_Role",
  permission: "SYSRA",
  feature: "SYSUserAdministration",
  database: {
    dataIdField: "Code",
    dbInsertMode: "Manual",
    useSchema: true,
  },
  server: {
    endpoint: "useradministration/role",
  },
  options: {
    initial_rowAttributes: {
      SYSPermissions: {
        translationKey: "SYSUserAdministrationPermissionTitle",
        useCount: true,
      },
    },
    initial_sort: { field: "Code", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
    customRowActions: {
      HandleRolePermission: {
        icon: "sap-icon--permission",
        translationKey: "SYSUserAdministrationHandleRolePermission",
        permission: "SYSRA",
      },
    },
  },
  features: {
    add: true,
    delete: true,
    edit: true,
    autoRebuild: "AfterModifyOrDelete",
  },
  columns,
}
